<template>
  <div >
    <v-head ref="header" ></v-head>
    <transition :name="transitionName" mode="out-in">
      <keep-alive :include="keepAliveList">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </transition>
    <v-footer />
  </div>
</template>

<script>
import vHead from './Header.vue';
import vFooter from './footer.vue';

export default {
  name: 'home',
  components: {
    vHead,
    vFooter
  },
  data(){
    return{
      transitionName: 'move',
      keepAliveList: ['index', 'article', 'common'],
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style  lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/index.vue